// extracted by mini-css-extract-plugin
export var container = "formum-container-module--container--VayKJ";
export var info = "formum-container-module--info--Gny4H";
export var message = "formum-container-module--message--ssO3R";